import { CommonModule } from '@angular/common';
import { Component, computed, inject, signal } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { CardComponent } from '@sportello-balneari/shared-components';
import { InputTextModule } from 'primeng/inputtext';
import { PaginatorModule, PaginatorState } from 'primeng/paginator';
import { CompilingSectionComponent } from '../../../components/tile/compiler/section/section.component';
import { BuilderStatusService } from '../../../services/builder/builder-status.service';
import { BuilderService } from '../../../services/builder/builder.service';
import { CompilingFormService } from '../../../services/compiling/compiling-form.service';
import { provideCompiling } from '../../../services/compiling/provide-compiling';
import { CompilingDashboardService } from '../../new-compiling-dashboard/compiling-dashboard.service';

@Component({
  selector: 'lib-playground',
  imports: [
    CommonModule,
    InputTextModule,
    CompilingSectionComponent,
    PaginatorModule,
    MatIconModule,
    MatButtonModule,
    CardComponent,
  ],
  providers: [provideCompiling()],
  templateUrl: './playground.component.html',
})
export class PlaygroundComponent {
  protected readonly builderStatusService = inject(BuilderStatusService);
  private readonly compilingDashboardService = inject(
    CompilingDashboardService,
  );
  private builderService = inject(BuilderService);
  protected forms = inject(CompilingFormService);

  first = signal<number>(0);
  sectionId = computed(() => {
    const start = this.first();
    const module = this.forms.moduleStructure();

    if (!module) return undefined;

    return module.root.children[start];
  });

  constructor() {
    this.forms.moduleStructure.set({
      ...this.builderService.moduleStructure(),
    });
  }

  onPageChange(event: PaginatorState) {
    console.log('onPageChange', event);
    this.first.set(event.first ?? 0);
  }

  loadAndFocus(sectionIndex: number, subsectionId: string) {
    this.first.set(sectionIndex);
    this.compilingDashboardService?.subSectionToFocus.set(subsectionId);
  }
}
